module.exports = __webpack_public_path__ + "img/vauraus_transparent.6adc9e4.png";